<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >ข้อมูลยื่นคำร้อง</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgentInfo"
                >ขอเปลี่ยนแปลงข้อมูลตัวแทน</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              เปลี่ยนแปลงเลขที่บัญชีธนาคาร
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgentInfo">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          เปลี่ยนแปลงเลขที่บัญชีธนาคาร
        </div>
      </div>
      <!-- Mobile -->
      <div class="col">
        <div
          class="title d-none d-lg-block border-bottom"
          style="font-family: DB Heavent; color: #0057a8"
        >
          เปลี่ยนแปลงเลขที่บัญชีธนาคาร
        </div>
        <div class="pb-3 pb-lg-3 border-bottom font-family fw-normal">
          <div class="mt-4 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2">
              เลขที่บัญชีเดิม
            </div>
          </div>
          <div class="mt-4 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2">
              เลขที่บัญชี :
            </div>
          </div>
          <div class="">
            <div class="blue-1 fs-4 d-lg-inline-block">{{ this.$store.state.AgentInfo.ACC_NO }}</div>
          </div>
          <div class="">
            <div class="gray-3 fs-5 d-lg-inline-block">
              บัญชีสะสมทรัพย์ ธนาคาร กรุงเทพ สาขา :
            </div>
          </div>
          <div class="">
            <div class="blue-1 fs-4 d-lg-inline-block">{{ this.$store.state.AgentInfo.ACC_BRANCH }}</div>
          </div>
        </div>
        <div class="pb-3 pb-lg-3 border-bottom font-family fw-normal">
          <div class="mt-4 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2">เปลี่ยนเป็น</div>
          </div>
          <div class="mt-2 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2">
              เลขที่บัญชี : <span class="required">*</span>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-6">
            <div class="fs-4 font-family">
              <input
                v-model="BankAccount"
                type="text"
                class="field__input a-field__input fs-6"
                style="font-family: monospace;"
                autocomplete="off"
                @keypress="isNumber($event)"
                maxlength="10"
              />
            </div>
          </div>
        </div>
        <div class="pb-3 pb-lg-3 border-bottom font-family fw-normal">
          <div class="mt-2 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2">
              บัญชีสะสมทรัพย์ ธนาคาร กรุงเทพ สาขา :
            </div>
          </div>
          <div class="mt-2 mt-lg-2">
            <div class="blue-1 fs-5 mt-lg-2">
              <v-select
                v-model="BranchBank"
                :reduce="(option) => option.value"
                :options="this.AllBranch"
                placeholder="กรุณาเลือกสาขาหรือพิมพ์ชื่อสาขาธนาคาร"
              />
            </div>
          </div>
          <div class="mt-2 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2">
              ขั้นตอนถัดไปกรุณาเตรียมเอกสารแนบ :
            </div>
          </div>
          <div class="blue-1 fs-5 d-lg-inline-block mt-lg-2">
            หน้าสมุดบัญชีเงินฝากธนาคาร กรุงเทพ จำกัด(มหาชน) ประเภทสะสมทรัพย์
          </div>
        </div>
        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button
              type="button"
              class="btn btn-light btn-cancel font-family d-inline-block"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
              <button
                type="button"
                class="btn btn-continue font-family d-inline-block"
                @click="EnterNext()"
              >
                ดำเนินการต่อ
              </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>

  <!-- Modal -->
  <div
    class="modal fade font-family"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light fw-normal popup_cancel"
            data-bs-dismiss="modal"
          >
            ไม่ต้องการ
          </button>
          <router-link to="/AgentInfo">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal" @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import Swal from 'sweetalert2/src/sweetalert2.js';
import http from "@/services/AuthService";

export default {
  name: "EditBankAccount",
  components: {
    Menu,
    LoadingBs5
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
    
    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetBranchBank",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      this.GetBranchBank(res.data);
    });
  },
  data() {
    return {
      BranchBank: this.$store.state.BranchName,
      BankAccount: this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_NO,
      AllBranch: [],
      Loading : false,
    };
  },
  methods: {
    EnterNext() {
      if(this.ValidateAccno(this.BankAccount, this.BranchBank)) {
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");

        this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_NO = this.BankAccount,
        this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_BANK = '002',
        this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_BRANCH = this.BranchNo(this.BranchBank),
        this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS = true;

        this.AllBranch.forEach(item => {
          if(item.value === this.BranchBank || item.label === this.BranchBank) {
            this.$store.state.BranchName = item.label;
          }
        });

        http.post("AgencyERequest/ValiDateAgentData", this.$store.state.EditAgentInfo, { headers: { Authorization: `Bearer ${AuthorizeToken}` }}).then((res) => { 
          if(res.status == 200) {
            if(res.data === 'TRUE') {
              Swal.fire({
                icon: 'error',
                html: '<lable class="fs-4 fw-normal font-family">เลขที่บัญชีนี้ถูกใช้โดยตัวแทนท่านอื่น</lable>',
              });
            }
            else {
              
              this.$router.push('/AgentInfo');
            }
          }
        }).catch((error) => { 
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาด</lable>',
          });

          this.ClearData();
          this.$router.push('/AgenteService');
        });
      }
      else { 
        this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_NO = '',
        this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_BANK = '',
        this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_BRANCH = '',
        this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS = false;
        this.$store.state.BranchName = '';
      }
    },
    GetBranchBank(ARY) {
      ARY.forEach(item => {
        let Branch = {
          id: item.SEQ,
          label: item.DESCRIPTION,
          value: item.ACC_BRANCH
        };

        this.AllBranch.push(Branch);
      });
    },
    ClearData() {
      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_NO = '',
      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_BANK = '',
      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_BRANCH = '',
      this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS = false;
      this.$store.state.BranchName = '';
    },
    ValidateAccno(val, val2){
      if(val.length != 10) {
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณากรอกเลขบัญชีให้ครบ</lable>',
        });
        return false;
      }
      else if (val2 == null || val2 === '') {
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณาเลือกสาขาบัญชีธนาคาร</lable>',
        });
        return false;
      }
      else {
        return true;
      }
    },
    BranchNo(val) {
      let BranchNo = '';

      this.AllBranch.forEach(item => {
        if(item.value === val || item.label === val) {
          BranchNo = item.value;
        }
      });

      return BranchNo;
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      let key = evt.key;
      let re = /^\d+.?\d*$/;
      if (re.test(key)) {
        return true;
      } else {
        evt.preventDefault();
      }
    }
  },
};
</script>

<style>
</style>